document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButton = document.getElementById('load-more');
  const scrollTopBtn = document.getElementById('scroll-top-btn');
  
  // Scroll top butonunu göster/gizle
  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      scrollTopBtn.classList.add('show');
    } else {
      scrollTopBtn.classList.remove('show');
    }
    
    // Otomatik yükleme kontrolü (buton görünürse tetikle)
    if (loadMoreButton && !loadMoreButton.classList.contains('loading')) {
      const rect = loadMoreButton.getBoundingClientRect();
      if (rect.top < window.innerHeight + 500) {
        loadMoreHandler();
      }
    }
  });

  // Scroll top butonu tıklama
  scrollTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

  // Load More buton tıklaması
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', loadMoreHandler);
  }

  async function loadMoreHandler() {
    if (!loadMoreButton || loadMoreButton.classList.contains('loading')) return;
    
    const nextUrl = loadMoreButton.dataset.nextUrl;
    const originalText = loadMoreButton.textContent;
    
    // Butonu yükleme durumuna getir
    loadMoreButton.disabled = true;
    loadMoreButton.textContent = 'Yükleniyor...';
    loadMoreButton.classList.add('loading');

    try {
      // Sayfa parametrelerini ekle (filtreleme için)
      const fullUrl = nextUrl + window.location.search;
      
      const response = await fetch(fullUrl);
      const html = await response.text();
      
      const parser = new DOMParser();
      const nextPage = parser.parseFromString(html, 'text/html');
      
      // Yeni ürünleri ekle
      const currentGrid = document.getElementById('product-grid');
      const newGrid = nextPage.getElementById('product-grid');
      
      if (newGrid) {
        const newItems = newGrid.querySelectorAll('.grid__item');
        newItems.forEach(item => {
          currentGrid.appendChild(item.cloneNode(true));
        });
      }

      // Yeni "Daha Fazla Yükle" butonunu güncelle
      const newButton = nextPage.getElementById('load-more');
      if (newButton) {
        loadMoreButton.dataset.nextUrl = newButton.dataset.nextUrl;
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = originalText;
        loadMoreButton.classList.remove('loading');
      } else {
        loadMoreButton.remove();
      }
    } catch (error) {
      console.error('Hata:', error);
      loadMoreButton.textContent = 'Hata! Tekrar Dene';
      loadMoreButton.disabled = false;
      loadMoreButton.classList.remove('loading');
    }
  }
});